export default __webpack_public_path__ + "static/media/computerImage.79841dcb.png";